import { render, staticRenderFns } from "./ConfirmationDeleteAccount.vue?vue&type=template&id=6621ebbb"
import script from "./ConfirmationDeleteAccount.vue?vue&type=script&lang=js"
export * from "./ConfirmationDeleteAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports